import { useEffect, useState } from "react";
import { useRouter } from "../useRouter";
import moment from "moment";

// 재구독 여부 확인
export function useCheckIsRenew({
  serviceList,
  serviceNo = 0,
}: {
  serviceList?: any;
  serviceNo?: number;
}) {
  const [isRenew, setIsRenew] = useState<boolean>(false);
  const route = useRouter();

  useEffect(() => {
    const params = new URLSearchParams(route.currentPath);
    if (params?.has("type") && params?.get("type") === "renew") {
      setIsRenew(true);
    }
    if (serviceList) {
      const nowTime = moment(Date.now());
      if (
        serviceList[serviceNo]?.billType === "PAY" &&
        serviceList[serviceNo]?.payStatus === "SUSPENDED"
      ) {
        setIsRenew(true);
      }
      if (
        serviceList[serviceNo]?.billType === "PROMOTION" &&
        serviceList[serviceNo]?.serviceEndTime < nowTime
      ) {
        setIsRenew(true);
      }
    }
  }, [serviceList]);

  return { isRenew };
}
